import { jsPDF } from 'jspdf';

const productFields = {
  tire: (p) => ({
    'Product ID': p.id,
    'Size': p.size,
    'Brand': p.tire_brand?.name || p.tireBrand?.name || '',
    'Type': p.tire_type?.name || p.tireType?.name || '',
    'Pattern': p.pattern?.name || '',
    'DOT': p.dot || '',
    'Construction': p.construction_type || '',
    'Run Flat': p.run_flat ? 'Yes' : 'No',
    'Cost Price': p.cost_price,
    'Selling Price': p.selling_price,
    'Tax Rate': `${p.tax_rate || 0}%`,
    'Tax Inclusive': p.is_tax_inclusive ? 'Yes' : 'No',
    'Quantity': p.quantity || p.total_quantity || 0,
    'Made In': p.made_in?.name || p.madeIn?.name || '',
    'Date Received': p.date_received || '',
    'Notes': p.notes || '',
  }),
  battery: (p) => ({
    'Product ID': p.id,
    'Name': p.battery_name,
    'Brand': p.battery_brand?.name || p.batteryBrand?.name || '',
    'Type': p.battery_type || '',
    'Shape': p.battery_shape || '',
    'Ampere': p.ampere || '',
    'Reversed': p.reversed ? 'Yes' : 'No',
    'Cost Price': p.cost_price,
    'Selling Price': p.selling_price,
    'Tax Rate': `${p.tax_rate || 0}%`,
    'Tax Inclusive': p.is_tax_inclusive ? 'Yes' : 'No',
    'Quantity': p.quantity || p.total_quantity || 0,
    'Made In': p.made_in?.name || p.madeIn?.name || '',
    'Date Received': p.date_received || '',
    'Notes': p.notes || '',
  }),
  wiper: (p) => ({
    'Product ID': p.id,
    'Size': p.size,
    'Type': p.type || '',
    'Frame Material': p.frame_material || '',
    'Compatibility Year': p.compatibility_year || '',
    'Compatible Cars': p.compatible_cars || '',
    'Cost Price': p.cost_price,
    'Selling Price': p.selling_price,
    'Tax Rate': `${p.tax_rate || 0}%`,
    'Tax Inclusive': p.is_tax_inclusive ? 'Yes' : 'No',
    'Quantity': p.quantity || p.total_quantity || 0,
    'Made In': p.made_in?.name || p.madeIn?.name || '',
    'Notes': p.notes || '',
  }),
};

export const exportProductToCSV = (product, productType) => {
  const fields = (productFields[productType] || productFields.tire)(product);
  const headers = Object.keys(fields).join(',');
  const values = Object.values(fields).map((v) => `"${String(v).replace(/"/g, '""')}"`).join(',');
  const csv = `${headers}\n${values}`;

  const blob = new Blob(['﻿' + csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${productType}-${product.id}.csv`;
  a.click();
  URL.revokeObjectURL(url);
};

export const exportProductToPDF = (product, productType) => {
  const fields = (productFields[productType] || productFields.tire)(product);
  const doc = new jsPDF();
  const typeLabel = productType.charAt(0).toUpperCase() + productType.slice(1);

  // Title
  doc.setFontSize(18);
  doc.setTextColor(33, 37, 41);
  doc.text(`${typeLabel} Product Summary`, 14, 20);

  // Product ID subtitle
  doc.setFontSize(10);
  doc.setTextColor(108, 117, 125);
  doc.text(`ID: ${product.id}`, 14, 28);
  doc.text(`Exported: ${new Date().toLocaleDateString()}`, 14, 34);

  // Divider
  doc.setDrawColor(200, 200, 200);
  doc.line(14, 38, 196, 38);

  // Fields
  doc.setFontSize(10);
  let y = 46;
  Object.entries(fields).forEach(([key, value]) => {
    if (y > 270) {
      doc.addPage();
      y = 20;
    }
    doc.setTextColor(108, 117, 125);
    doc.text(key, 14, y);
    doc.setTextColor(33, 37, 41);
    doc.text(String(value), 80, y);
    y += 8;
  });

  doc.save(`${productType}-${product.id}.pdf`);
};

export const exportProduct = (product, productType, format = 'csv') => {
  if (format === 'pdf') {
    exportProductToPDF(product, productType);
  } else {
    exportProductToCSV(product, productType);
  }
};
